import { EnergySwitchSteps } from 'components/common/energy-switch-steps/EnergySwitchSteps';

export const testId = 'directSalesFooterTestId';

export const DirectSalesFooter = () => {
  return (
    <div data-testid={testId}>
      <EnergySwitchSteps />
    </div>
  );
};

export default DirectSalesFooter;
